import { MutationTree } from 'vuex';
import { ISetDocumentRevisionStatusPayload } from '../types';
import { IDealroomViewState } from './dealroom-view.store';
import { IDocument } from '@/types/Document';
import { IField } from '@/dealroom/fields/types/field';
import { IDocumentPage } from '@/types/document-page';
import { IDocumentRevision } from '@/types/document-revision';

export const mutationSetLoading = 'setLoading';
export const mutationSetLoaded = 'setLoaded';
export const mutationSetDocument = 'setDocument';
export const mutationSetDocumentRevisions = 'setDocumentRevisions';
export const mutationSetDocumentRevisionStatus = 'setDocumentRevisionStatus';
export const mutationSetRevisionsLoading = 'setRevisionsLoading';
export const mutationSetUpdateFailed = 'setUpdateFailed';
export const mutationSetFields = 'setFields';
export const mutationSetPageWidth = 'setPageWidth';
export const mutationSetPages = 'setPages';

export const mutations: MutationTree<IDealroomViewState> = {
  [mutationSetLoading](state: IDealroomViewState, loading: boolean) {
    state.loading = loading;
  },
  [mutationSetLoaded](state: IDealroomViewState, loaded: boolean) {
    state.loaded = loaded;
  },
  [mutationSetDocument](state: IDealroomViewState, document: IDocument) {
    state.document = { ...document };
  },
  [mutationSetDocumentRevisions](
    state: IDealroomViewState,
    documentRevisions: IDocumentRevision[]
  ) {
    state.document.documentRevisions = documentRevisions;
  },
  [mutationSetDocumentRevisionStatus](
    state: IDealroomViewState,
    payload: ISetDocumentRevisionStatusPayload
  ) {
    state.document.documentRevisions = state.document.documentRevisions.map(
      (documentRevision: IDocumentRevision) =>
        documentRevision.revision === payload.revision
          ? { ...documentRevision, status: payload.status }
          : documentRevision
    );
  },
  [mutationSetRevisionsLoading](state: IDealroomViewState, loading: boolean) {
    state.revisionsLoading = loading;
  },
  [mutationSetFields](state: IDealroomViewState, fields: IField[]) {
    state.fields = fields;
  },
  [mutationSetPageWidth](state: IDealroomViewState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [mutationSetPages](state: IDealroomViewState, pages: IDocumentPage[]) {
    state.document.pages = pages;
  },
  [mutationSetUpdateFailed](state: IDealroomViewState) {
    state.updateFailed = true;
  },
};
